module.exports = __webpack_public_path__ + "img/declinedorder.c973e736.png";